export default "__VITE_ASSET__11f4ae34__"